import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Calendar } from '@/modules/calendar/model/calendar/calendar';
import { selectApi } from '@/modules/calendar/api';
import { NewsEvent } from '@/modules/calendar/model/calendar/news-event';
import { CountryFlag } from '@/shared/components/export';
import { CoverageBadges } from '@/modules/calendar/components/data-calendar/coverage/coverage-badges';
import { WidgetLink } from '@/core/widgets/export';

export default function Events({ calendar }: { calendar: Calendar }) {
  const [events, setEvents] = useState<NewsEvent[]>();

  useEffect(() => {
    if (calendar) {
      selectApi.getEventsFromCalendarWithWindow(calendar.id, calendar.window).then(setEvents);
    }
  }, [calendar]);

  return (
    <>
      <div className={''}>
        {events && events.length > 0 && (
          <div className={' text-center border-bottom pb-3'}>
            <div className={'mb-3'}>
              <WidgetLink to={`/event/${events[0].id}`} className={'text-decoration-none'}>
                <h4 className={'text-muted'}>Next Event</h4>
                <h2>
                  <CountryFlag country={events[0].country} width={30} /> {events[0].title}
                </h2>
                <span className="small text-base-dark">See details</span>
              </WidgetLink>
            </div>

            <div className={'row d-flex'}>
              <div className={'col-sm-4 offset-sm-2'}>
                <h3>{dayjs(events[0].date).format('MMM D')}</h3>
              </div>
              <div className={'col-sm-4 text-muted mt-auto mb-auto '}>
                <h3>{dayjs(events[0].date).fromNow()}</h3>
                <CoverageBadges event={events[0]} />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className={' overflow-auto'}>
        <div className={''}>
          <table className={'table table-sm container-responsive-text-sm '}>
            <tbody>
              {events?.slice(1).map(value => (
                <>
                  <tr key={value.id}>
                    <td className={'text-muted'}>{dayjs(value.date).format('MMM D')}</td>
                    <td>
                      <WidgetLink
                        to={`/event/${value.id}`}
                        className={'dropdown-item px-0 text-decoration-none'}
                      >
                        <span className={'h-100 '}>
                          <CountryFlag country={value.country} width={20} />
                        </span>

                        <span className={'ms-1'}>{value.title}</span>
                        <span className="ms-2 small text-base-dark">See details</span>
                      </WidgetLink>
                    </td>
                    <td className={'text-end text-muted'}>{dayjs(value.date).fromNow()}</td>
                  </tr>
                  {value.relatedEvents?.map(related => (
                    <tr key={related.id}>
                      <td className={'text-muted'}>{dayjs(related.date).format('MMM D')}</td>
                      <td>
                        <WidgetLink
                          to={`/event/${related.id}`}
                          className={'dropdown-item px-0 text-decoration-none'}
                        >
                          <span className={'h-100 '}>
                            <CountryFlag country={related.country} width={20} />
                          </span>

                          <span className={'ms-1'}>{related.title}</span>
                          <span className="ms-2 small text-base-dark">See details</span>
                        </WidgetLink>
                      </td>
                      <td className={'text-end text-muted'}>{dayjs(related.date).fromNow()}</td>
                    </tr>
                  ))}
                </>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
